import { CSSProperties } from "@material-ui/core/styles/withStyles";
import * as typeStyles from "@clockwise/web-commons/src/styles/type.styles";
import { background } from "@clockwise/web-commons/src/styles/color.styles";
import { CHROME_MAX_WIDTH } from "@components/chrome-wrapper/ChromeWrapper.styles";

export const modernStyles: CSSProperties = {
  fontFamily: typeStyles.fontFamilySans,
  fontStyle: "normal",
  fontVariant: "normal",
  fontWeight: "normal",
  backgroundColor: background.page,
};

// loader in the renderer
export const container: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  position: "absolute",
  alignItems: "center",
  justifyContent: "center",
  height: 500,
};

export const chromeContainer: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  top: 0,
  bottom: 0,
  right: 0,
  width: CHROME_MAX_WIDTH,
  position: "absolute",
  alignItems: "center",
  justifyContent: "center",
};
